import AuthService from "../../../../services/auth_service";

const Submit = (vm) => {
    const submit = async (e) => {
        e.preventDefault();
        vm.setLoading(true);
        try {
            if (!vm.code || !vm.resetToken) {
                vm.message("Enlace invalido o expirado", "error");
                return;
            }
            if (!vm.active) {
                vm.message("El enlace ya no esta activo. Genera uno nuevo", "warning");
                return;
            }
            if (vm.password !== vm.confirm || !vm.password) {
                vm.message("Las contrasenas no coinciden", "error");
                return;
            }
            const update = await AuthService.updatePassword({
                sessionId: vm.code,
                resetToken: vm.resetToken,
                newPassword: vm.password,
            });
            if (vm.logout(update)) return;
            if (update) {
                vm.setRedirecting(true);
                vm.message("Contrasena actualizada correctamente", "success");
                window.history.replaceState({}, "", "/");
                setTimeout(() => vm.onBackToLogin(), 1000);
            } else {
                vm.message("No se pudo actualizar la contrasena", "error");
            }
        } catch (exp) {
            vm.message(exp?.message || "Error al actualizar. Intenta nuevamente", "error");
        } finally {
            vm.setLoading(false);
        }
    };

    return submit
};

export default Submit;
